export enum Ranges {
  'DAY' = 'day', // Not exists in endpoint. Used internally to handle "per day" range
  'WEEK' = 'week',
  'WEEK2' = 'week2',
  'MONTH' = 'month',
  'QUARTER' = 'quarter',
  'HALFYEAR' = 'halfyear',
  'YEAR' = 'year',
}

export interface Range {
  month: any // TODO: TK: Deprecated - to be removed

  range: Ranges
  year: number
  namePL: string
  nameEN: string
  start: string
  end: string
}

export interface System {
  errorMessage: string
  errorTill: string | null
  errorType: string | null
  ranges: Range[]
  isProd: boolean
}
